"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var page_margin_positioner_html_1 = __importDefault(require("./page-margin-positioner.html"));
require("./page-margin-positioner.less");
// Directive to ensure all child elements are inside the margins
(function (module) {
    module.directive('prPageMarginPositioner', [
        'prEventService',
        'prPageLayoutService',
        function (eventService, pageLayout) {
            return {
                scope: false,
                templateUrl: page_margin_positioner_html_1.default,
                transclude: true,
                link: function (_$scope, $element) {
                    function setStyles() {
                        $element.children().css(getStyles());
                    }
                    eventService.on('updatePageMargins', setStyles);
                    $element.on('$destroy', function () {
                        eventService.off('updatePageMargins', setStyles);
                    });
                    setStyles();
                }
            };
            function getStyles() {
                var margins = pageLayout.getMargins();
                return lodash_1.default.mapValues(margins, function (val, key) {
                    // shift the top-left over by 1px for perfect alignment
                    var shiftAmount = (key === 'top' || key === 'left') ? 1 : 0;
                    // if the element is already at the edge it shouldn't move past it
                    return Math.max((val - shiftAmount), 0) + 'px';
                });
            }
        }
    ]);
})(angular_1.module('qualtrics.pr'));
